export default "__VITE_ASSET__CbTcP4Ng__"